import $ from "jquery";

const ajaxGetWcPrice = (price) => {
  $('.Header--Customizer').find('.Header__Body__Content').addClass('mi-component-loading');
  return new Promise((resolve, reject) =>
    $.ajax({
      type: "POST",
      dataType: "json",
      // eslint-disable-next-line no-undef
      url: themeObj.ajaxUrl,
      data: {
        action: "AjaxGetWcPriceFormat",
        price: price,
      },
      success: function (response) {
        $('.Header--Customizer').find('.Header__Body__Content').removeClass('mi-component-loading');
        resolve(response);
      },
      error: (err) => {
        $('.Header--Customizer').find('.Header__Body__Content').removeClass('mi-component-loading');
        reject(new Error(err));
      },
    })
  );
};

export default ajaxGetWcPrice;
